import { Dialog } from "primereact/dialog";
import { Button } from "primereact/button";
import { useTranslation } from "react-i18next";
import { useStorePos } from "./useStorePos";

const PosPopupCatalogarLinea = () => {
  const { t } = useTranslation();
  const visible = useStorePos((s) => s.CatalogoLineaVisible);
  const linea = useStorePos((s) => s.CatalogoLinea);
  const catalogando = useStorePos((s) => s.CatalogandoLinea);
  const setCampo = useStorePos((s) => s.setCatalogoLineaCampo);
  const cerrar = useStorePos((s) => s.cerrarCatalogarLinea);
  const catalogar = useStorePos((s) => s.catalogarLinea);

  if (!linea) return null;

  const header = (
    <div className="pos-precios-dialog-header">
      <span className="pos-precios-header-icon">
        <i className="pi pi-book" />
      </span>
      <div>
        <h3>{t("products.catalogProduct")}</h3>
        <p>{t("products.detailNumber", { number: linea.DetalleId || 0 })}</p>
      </div>
    </div>
  );

  return (
    <Dialog
      header={header}
      position="center"
      visible={visible}
      style={{ width: "min(860px, 94vw)", height: "auto" }}
      breakpoints={{ "768px": "96vw", "480px": "98vw" }}
      maximizable={false}
      contentStyle={{ backgroundColor: "white", padding: 0 }}
      closable={true}
      onHide={cerrar}
      className="pos-dialog pos-precios-dialog pos-catalogo-dialog"
    >
      <div className="pos-precios-modal pos-catalogo-modal">
        <div className="pos-precios-topbar">
          <span className="pos-precios-note">
            <i className="pi pi-info-circle" />
            {t("products.catalogDefinitionHelp")}
          </span>
          <span className="pos-catalogo-chip">{t("products.lineNumber", { number: linea.Indice || 0 })}</span>
        </div>

        <div className="pos-catalogo-grid">
          <div className="pos-campo pos-campo-ancho">
            <div className="camp-o">
              <label>{t("common.description")}</label>
            </div>
            <input
              type="text"
              value={linea.Descripcion || ""}
              onChange={(e) => setCampo("Descripcion", e.target.value)}
              placeholder={t("products.product")}
            />
          </div>

          <div className="pos-campo">
            <div className="camp-o">
              <label>{t("products.goodsType")}</label>
            </div>
            <div className="pos-dato-solo-lectura">{t("products.rawMaterial")}</div>
          </div>

          <div className="pos-campo">
            <div className="camp-o">
              <label>{t("common.unit")}</label>
            </div>
            <input
              type="text"
              value={linea.Unidad?.sDescripcion || ""}
              onChange={(e) =>
                setCampo("Unidad", {
                  ...(linea.Unidad || {}),
                  sCodigo: e.target.value,
                  sDescripcion: e.target.value,
                })
              }
              placeholder={t("products.unitPlaceholder")}
            />
          </div>

          <div className="pos-campo">
            <div className="camp-o">
              <label>{t("pos.stock")}</label>
            </div>
            <label className="pos-checkbox-line">
              <input
                type="checkbox"
                checked={!!linea.LlevaStock}
                onChange={(e) => setCampo("LlevaStock", e.target.checked)}
              />
              <span>{t("products.tracksStock")}</span>
            </label>
          </div>

          <div className="pos-campo">
            <div className="camp-o">
              <label>{t("products.standardQuantity")}</label>
            </div>
            <input
              type="number"
              min="1"
              step="1"
              value={linea.CantidadEstandar || 1}
              onChange={(e) => setCampo("CantidadEstandar", Number(e.target.value) || 1)}
            />
          </div>

          <div className="pos-campo">
            <div className="camp-o">
              <label>{t("products.standardWeight")}</label>
            </div>
            <input
              type="number"
              min="0"
              step="0.01"
              value={linea.PesoEstandar || 0}
              onChange={(e) => setCampo("PesoEstandar", Number(e.target.value) || 0)}
            />
          </div>

          <div className="pos-campo">
            <div className="camp-o">
              <label>{t("products.expirationDays")}</label>
            </div>
            <input
              type="number"
              min="0"
              step="1"
              value={linea.VencimientoCantidad || 0}
              onChange={(e) => setCampo("VencimientoCantidad", Number(e.target.value) || 0)}
            />
          </div>

          <div className="pos-campo">
            <div className="camp-o">
              <label>{t("products.perDay")}</label>
            </div>
            <label className="pos-checkbox-line">
              <input
                type="checkbox"
                checked={!!linea.VencimientoPorDia}
                onChange={(e) => setCampo("VencimientoPorDia", e.target.checked)}
              />
              <span>{t("products.expiresPerDay")}</span>
            </label>
          </div>
        </div>

        <div className="pos-catalogo-preview">
          <strong>{linea.Descripcion || t("products.unnamedProduct")}</strong>
          <span>
            {linea.LlevaStock ? t("products.withStockControl") : t("products.withoutStockControl")}
          </span>
        </div>

        <div className="pos-catalogo-footer">
          <Button label={t("common.cancel")} className="pos-btn-secondary" onClick={cerrar} />
          <Button
            label={catalogando ? t("products.cataloging") : t("products.catalogProduct")}
            className="pos-btn-primary"
            onClick={catalogar}
            loading={catalogando}
          />
        </div>
      </div>
    </Dialog>
  );
};

export default PosPopupCatalogarLinea;
